import React, { useContext } from 'react';
import { FormattedMessage, useIntl, IntlContext } from 'react-intl';
import { useFormikContext } from 'formik';
import { SelectFieldWithLabel, RadioButtonsWithLabel, TextFieldWithLabel, SelectFieldWithLabelAndSpinner } from '../../../components/FormFields';
import { constants } from '../../../constants'
import ClientAccounts from './ClientAccounts'
import { currentLang } from '../../../components/components/utils';

export default function EFilingMainInfoTabBody(props) {
	
	const { values, setFieldValue } = useFormikContext();
	const { messages } = useContext(IntlContext);
	
	const labels = {
		"sima.representative.add.client"              : useIntl().formatMessage({id:"sima.representative.add.client"}, {i: (chunks) => <i>{chunks}</i>})
		, "sima.representative.add.client.options.no" : useIntl().formatMessage({id:"sima.representative.add.client.options.no"}, {i: (chunks) => <i>{chunks}</i>})
		, "http.networkError"                         : useIntl().formatMessage({id:"http.networkError"}, {p: (chunks) => <p>{chunks}</p>, a: (chunks) => <a href={"https://www.cbsa-asfc.gc.ca/contact/bis-sif-"+(document.documentElement.lang === "fr" ? "fra" : "eng")+".html"} className="App-link" target="_blank" rel="noreferrer">{chunks}</a>})
		, "sima.representative.counsel"               : useIntl().formatMessage({id:"sima.representative.counsel"}, {a: (chunks) => <a target="_blank" href={"https://www.cbsa-asfc.gc.ca/sima-lmsi/forms-formulaires/letter-of-authorization-"+(document.documentElement.lang === "fr" ? "fra" : "eng")+".html"}>{chunks}</a>, newWindowIcon: <span className="glyphicon glyphicon-new-window"></span>})
		, "sima.role.not.counsel.BN"   : useIntl().formatMessage({id:"sima.role.not.counsel.BN"}, {abbr: (chunks) => <abbr title="A 15-character alphanumeric identifier assigned by the Canada Revenue Agency to identify a business, made up of the 9 digit business number appended by a 6 digit alpha-numerical number used to uniquely identify the business’s import/export accounts (e.g., 123456789RM0001)">{chunks}</abbr>, a: (chunks) => <a href="#fn2">{chunks}</a>, sup: (chunks) => <sup id="fn2-rf">{chunks}</sup>})
	}

	const {roles} = props.codeTables;

	let activeProceedingsOptions = props.activeProceedings.current
	let activeFirmAccountOptions = props.activeFirmAccounts.current
	let accountBusinessNumber = props.accountDataBusinessNumber.current

	const counselSubmissionQuestion = {
		"en" : [
			{"value":"true", "label":"Yes"}
			,{"value":"false", "label":labels["sima.representative.add.client.options.no"]}
		]
		, "fr" : [
			{"value":"true", "label":"Oui"}
			,{"value":"false", "label":labels["sima.representative.add.client.options.no"]}
		]
	}

	const handleRoleChange = () => {
		setFieldValue("representative", null);
		setFieldValue("addClient", "");
	}

	// This is the Participating Party Info tab

	return (
		<div className="form-group col-md-12 text-left row-magic">
		  <h2><FormattedMessage id="sima.document.title.0"/></h2>
		  <br />
		  {values.typeOfSubmission === constants.typeOfSubmissions["Response to Disclosure-Related Deficiency Notice"] ? 
		  	<div>
		  	  <SelectFieldWithLabelAndSpinner id="proceedingIdentifier" name="proceedingIdentifier" label={messages["sima.proceeding.identifier"]}
		  	    required={true}
		  	    disabled={true} 
		  	    options={[
		  	    	...activeProceedingsOptions
		  	    ]}
		  	  />
		  	</div>
		  :
		  	<SelectFieldWithLabelAndSpinner id="proceedingIdentifier" name="proceedingIdentifier" label={messages["sima.proceeding.identifier"]}
		  	  options={[
		  	  	...activeProceedingsOptions
		  	  ]}
		  	/>
		  }
		  <SelectFieldWithLabel id="role" name="role" required={true} label={messages["sima.role"]}
		    onChange={handleRoleChange}
		    options={[
		    	{value:"", label: messages["common.select..."]}
		    	, ...roles
		    ]}
		  />
		  {values.role !== "" && values.role !== constants.roles["Counsel"] ? 
		  	<>
		  	  <TextFieldWithLabel id="businessNumberForSubmission" name="businessNumberForSubmission" required={true} readonly="readonly" label={labels["sima.role.not.counsel.BN"]} placeholder={accountBusinessNumber} />
		  	  <div className="form-group col-md-12 magical-incantation"><div className="col-md-12"><FormattedMessage id="sima.role.not.counsel.BN.text" /></div></div>
		  	  <RadioButtonsWithLabel id="representative" name="representative" required={false} label={labels["sima.representative.counsel"]} 
		  	    options={constants.yesNo[currentLang()]}
		  	  />
		  	</>
		  :
		  	values.role === constants.roles["Counsel"] ?
		  		<>
		  		  <RadioButtonsWithLabel id="addClient" name="addClient" required={true} label={labels["sima.representative.add.client"]} 
		  		    options={counselSubmissionQuestion[currentLang()]}
		  		  />
		  		</> 
		  	:<></>
		  }
		  {values.representative === "true" && values.role !== constants.roles["Counsel"] ? 
		  	<>
		  	  <SelectFieldWithLabel id="representativeCounsel" name="representativeCounsel" required={true} label={messages["sima.representative.counsel.dropdown"]}
		  	    options={[
		  	    	...activeFirmAccountOptions
		  	    ]}
		  	  />
		  	  <div className="form-group col-md-12 magical-incantation"><div className="col-md-12"><FormattedMessage id="sima.representative.counsel.note" values={{a: (chunks) => <a href="mailto:simaregistry-depotlmsi@cbsa-asfc.gc.ca">{chunks}</a>}} /></div></div>
		  	</>
		  :<></>
		  }
		  {values.role === constants.roles["Counsel"] && values.addClient === "true" ? 
		  	<>
		  	  <br />
		  	  <ClientAccounts FieldArrayHelpersRef={props.FieldArrayHelpersRef} setDisplayPopup={props.setDisplayPopup}/>
		  	</>
		  :	values.role === constants.roles["Counsel"] && values.addClient === "false" ? 
		  	<>
		  	  <div className="form-group col-md-12 magical-incantation"><div className="col-md-12"><FormattedMessage id="sima.representative.add.client.no.disclaimer" values={{strong: (chunks) => <strong>{chunks}</strong>, i: (chunks) => <i>{chunks}</i>}} /></div></div>
		  	</>:<></>
		  }
		  {values.role !== "" && values.role !== constants.roles["Counsel"] ?
		  	<>
		  	  <div className="form-group col-md-12 magical-incantation">
		  	    <div className="col-md-12">
		  	      <aside>
		  	        <h3><FormattedMessage id="sima.document.footnote" /></h3>
		  	        <dl>
		  	          <dt><a href="#fn2-rf">[1]</a> <FormattedMessage id="sima.counsel.client.header.2" /></dt>
		  	          <dd id="fn2">
		  	          <p><FormattedMessage id="sima.account.accountInfo.businessNumber.description.footnote" /></p>
		  	          </dd>
		  	        </dl>
		  	      </aside>
		  	    </div>
		  	  </div>
		  	</> : <></>
		  }
		</div>
	);
}
